const API_URL = 'https://api.vdovareize.me'
// const API_URL = 'http://localhost:3000'

const constants = {
    FIBONACCI_URL: `${API_URL}/clouds/fibonacci`,
    PRIME_URL: `${API_URL}/clouds/prime`,
    ARMSTRONG_URL: `${API_URL}/clouds/armstrong`,
    RESULT_URL: `${API_URL}/async/result`,
}

export default constants